import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import MapResultsGrid from 'src/components/pages/map/tabs/items/all/MapResultsGrid'
import { useGetMapPropertiesQuery } from 'src/redux/api'
import ErrorState from 'src/components/elements/error-state/ErrorState'
import { Skeleton } from '@mui/material'

// How many of the newest listings the fresh strip shows; the full feed below
// continues after them.
export const FRESH_LISTINGS_COUNT = 8

// Latest listings on the home page — same cards as the map results grid.
// Hidden entirely while the marketplace has nothing to show.
const FreshListings: FC = () => {
  const { t } = useTranslation()
  const { data, isLoading, isError, refetch } = useGetMapPropertiesQuery({
    sort: 'createdAt desc',
    limit: FRESH_LISTINGS_COUNT,
  })
  const items = (data?.properties || []).slice(0, FRESH_LISTINGS_COUNT)

  // The strip keeps its place while it loads and says so when it fails,
  // instead of appearing late or not at all.
  if (isLoading || isError) {
    return (
      <section className="flex flex-col gap-3">
        <h2 className="text-xl md:text-[1.375rem] font-extrabold leading-tight text-ink">
          {t('home_fresh.title')}
        </h2>
        {isError ? (
          <ErrorState onRetry={refetch} />
        ) : (
          <div className="grid gap-4 grid-cols-[repeat(auto-fill,minmax(15rem,1fr))]">
            {[0, 1, 2].map((placeholder) => (
              <Skeleton key={placeholder} variant="rounded" height={220} />
            ))}
          </div>
        )}
      </section>
    )
  }
  if (items.length === 0) return null

  return (
    <section className="flex flex-col gap-3">
      <div className="flex items-center justify-between gap-2">
        <h2 className="text-xl md:text-[1.375rem] font-extrabold leading-tight text-ink">
          {t('home_fresh.title')}
        </h2>
        <Link
          to="/map"
          className="shrink-0 inline-flex items-center min-h-11 text-sm font-extrabold text-brand-ink hover:underline"
        >
          {t('home_fresh.see_all')} →
        </Link>
      </div>
      <MapResultsGrid properties={items} mobileCarousel />
    </section>
  )
}

export default FreshListings
